import { render, staticRenderFns } from "./HomeStrategic.vue?vue&type=template&id=8d8ea578&scoped=true&"
import script from "./HomeStrategic.vue?vue&type=script&lang=js&"
export * from "./HomeStrategic.vue?vue&type=script&lang=js&"
import style0 from "./HomeStrategic.vue?vue&type=style&index=0&id=8d8ea578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8ea578",
  null
  
)

component.options.__file = "HomeStrategic.vue"
export default component.exports